import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface ICaseReferralProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    caseId: IPropertyInfoMetadata;
    venueId: IPropertyInfoMetadata;
    localAuthorityCapitaReference: IPropertyInfoMetadata;
    homeTown: IPropertyInfoMetadata;
    school: IPropertyInfoMetadata;
    schoolYear: IPropertyInfoMetadata;
    schoolType: IPropertyInfoMetadata;
    schoolRepresentative: IPropertyInfoMetadata;
    primarySn: IPropertyInfoMetadata;
    childStatementedDate: IPropertyInfoMetadata;
    tribunalDate: IPropertyInfoMetadata;
    tribunalReferenceNumber: IPropertyInfoMetadata;
    confidentialityExplained: IPropertyInfoMetadata;
    mediationPermissionAgreed: IPropertyInfoMetadata;
    completedByStaffMemberId: IPropertyInfoMetadata;
    completedDate: IPropertyInfoMetadata;
    status: IPropertyInfoMetadata;
    venueRequirements: IPropertyInfoMetadata;
    mediatorId: IPropertyInfoMetadata;
    datesToAvoid: IPropertyInfoMetadata;
    localAuthorityMediationPossible: IPropertyInfoMetadata;
    psName: IPropertyInfoMetadata;
    psJobTitle: IPropertyInfoMetadata;
    officerLocalAuthorityGroupStaffMemberId: IPropertyInfoMetadata;
    localAuthorityOfficer: IPropertyInfoMetadata;
    localAuthorityOfficerJobTitle: IPropertyInfoMetadata;
    localAuthorityOfficerEmail: IPropertyInfoMetadata;
    localAuthorityOfficerPhone: IPropertyInfoMetadata;
    localAuthorityDeclinedReason: IPropertyInfoMetadata;
    schoolRepresentativeName: IPropertyInfoMetadata;
    schoolRepresentativeJobTitle: IPropertyInfoMetadata;
    attOtherGroup1: IPropertyInfoMetadata;
    attOtherGroup1Name: IPropertyInfoMetadata;
    attOtherGroup1Title: IPropertyInfoMetadata;
    mediationRequestDate: IPropertyInfoMetadata;
    preferredMediationTime: IPropertyInfoMetadata;
    proposedDate: IPropertyInfoMetadata;
    clientProposedDate: IPropertyInfoMetadata;
    mediationDateChosen: IPropertyInfoMetadata;
    mediationStartTimeChosen: IPropertyInfoMetadata;
    mediationEndTimeChosen: IPropertyInfoMetadata;
    venueFullAddress: IPropertyInfoMetadata;
    mediationTookPlace: IPropertyInfoMetadata;
    cancellationReason: IPropertyInfoMetadata;
    emProvider: IPropertyInfoMetadata;
    purchaseOrderNumber: IPropertyInfoMetadata;
    mediationStatusLookupItemId: IPropertyInfoMetadata;
    videoMeetingMeetingRoom: IPropertyInfoMetadata;
    videoMeetingTimeSlot: IPropertyInfoMetadata;
    welcomer: IPropertyInfoMetadata;
    mediationTypeLookupItemId: IPropertyInfoMetadata;
    videoMeetingInformation: IPropertyInfoMetadata;
    zoomAccount: IPropertyInfoMetadata;
    meetingLeadTimeDisabled: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    case: IPropertyInfoMetadata;
    officerLocalAuthorityGroupStaffMember: IPropertyInfoMetadata;
    mediator: IPropertyInfoMetadata;
    completedByStaffMember: IPropertyInfoMetadata;
    venue: IPropertyInfoMetadata;
    mediationStatusLookupItem: IPropertyInfoMetadata;
    mediationTypeLookupItem: IPropertyInfoMetadata;

    // #endregion

}

export const CaseReferral: ITypeInfoMetadata<ICaseReferralProperties> = {
    attributes: [
        {
            id: "{983E0B77-1FE8-402B-99F8-A9E3F5587383}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "CaseReferral",
            nameFriendly: "Case Referral",
            namePlural: "CaseReferrals",
            namePluralFriendly: "Case Referrals",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.CaseReferral, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "CaseReferral",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        caseId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case"
                },
                {
                    entityDescriptionProperty: "ListDescription",
                    entityName: "Case",
                    entityNameFriendly: "Case",
                    entityNamePlural: "Cases",
                    entityNamePluralFriendly: "Cases",
                    foreignEntityAlias: "CaseReferral",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseReferral+CaseIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        venueId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Venue"
                },
                {
                    entityDescriptionProperty: "CompanyName",
                    entityName: "Venue",
                    entityNameFriendly: "Venue",
                    entityNamePlural: "Venues",
                    entityNamePluralFriendly: "Venues",
                    foreignEntityAlias: "CaseReferrals",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VenueId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityCapitaReference: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Capita Reference"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityCapitaReference",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        homeTown: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Home Town"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HomeTown",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        school: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 4
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "School",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schoolYear: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School Year"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 5
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchoolYear",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schoolType: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 6
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchoolType",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schoolRepresentative: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School Representative"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 7
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchoolRepresentative",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        primarySn: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Primary SN"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 8
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PrimarySn",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        childStatementedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Date Child Statemented"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 9
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ChildStatementedDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        tribunalDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Date of any Tribunal Case"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 10
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TribunalDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        tribunalReferenceNumber: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Tribunal Ref No"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 11
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TribunalReferenceNumber",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        confidentialityExplained: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Confidentiality Explained"
                },
                {
                    helpText: "Has Global's policy on Confidentiality been explained?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 12
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ConfidentialityExplained",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationPermissionAgreed: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Permission Agreed"
                },
                {
                    helpText: "Has Parent/Carer given permission for mediation-related information to be disclosed to LA?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseReferral+MediationPermissionAgreedMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 13
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationPermissionAgreed",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        completedByStaffMemberId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Completed By"
                },
                {
                    entityDescriptionProperty: "FullName",
                    entityName: "StaffMember",
                    entityNameFriendly: "Staff Member",
                    entityNamePlural: "StaffMembers",
                    entityNamePluralFriendly: "Staff Members",
                    foreignEntityAlias: "CaseReferralsByCompletedByStaffMember",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseReferral+CompletedByStaffMemberIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 14
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CompletedByStaffMemberId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        completedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Completed Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseReferral+CompletedDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareReadOnlyAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 15
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CompletedDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        status: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Status"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 16
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Status",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        venueRequirements: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Venue Requirements"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 17
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VenueRequirements",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediator"
                },
                {
                    entityDescriptionProperty: "FullName",
                    entityName: "Mediator",
                    entityNameFriendly: "Mediator",
                    entityNamePlural: "Mediators",
                    entityNamePluralFriendly: "Mediators",
                    foreignEntityAlias: "CaseReferrals",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 18
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        datesToAvoid: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Dates to Avoid"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 19
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DatesToAvoid",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityMediationPossible: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Mediation Possible"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 20
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityMediationPossible",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        psName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "PS Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 21
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PsName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        psJobTitle: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "PS Job Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 22
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PsJobTitle",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        officerLocalAuthorityGroupStaffMemberId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Local Authority Officer"
                },
                {
                    entityDescriptionProperty: "FullName",
                    entityName: "LocalAuthorityGroupStaffMember",
                    entityNameFriendly: "Local Authority Group Staff Member",
                    entityNamePlural: "LocalAuthorityGroupStaffMembers",
                    entityNamePluralFriendly: "Local Authority Group Staff Members",
                    foreignEntityAlias: "CaseReferrals",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 23
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OfficerLocalAuthorityGroupStaffMemberId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityOfficer: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Officer"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 24
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityOfficer",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityOfficerJobTitle: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Officer Job Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 25
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityOfficerJobTitle",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityOfficerEmail: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Officer Email"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 26
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityOfficerEmail",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityOfficerPhone: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "LA Officer Phone"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 27
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityOfficerPhone",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityDeclinedReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Local Authority Declined Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 28
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 512,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityDeclinedReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schoolRepresentativeName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School Representative Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 29
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchoolRepresentativeName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schoolRepresentativeJobTitle: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School Representative Job Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 30
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchoolRepresentativeJobTitle",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        attOtherGroup1: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "ATT Other Group 1"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 31
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AttOtherGroup1",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        attOtherGroup1Name: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "ATT Other Group 1 Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 32
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AttOtherGroup1Name",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        attOtherGroup1Title: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "ATT Other Group 1 Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 33
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AttOtherGroup1Title",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationRequestDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Request Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 34
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationRequestDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        preferredMediationTime: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Preferred Mediation Time"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 35
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PreferredMediationTime",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        proposedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Proposed Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 36
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ProposedDate",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        clientProposedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Client Proposed Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 37
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClientProposedDate",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationDateChosen: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "MediationDate Chosen"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 38
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationDateChosen",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationStartTimeChosen: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Start Time Chosen"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 39
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationStartTimeChosen",
            propertyTypeId: "System.Nullable`1[[System.TimeOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationEndTimeChosen: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation End Time Chosen"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 40
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationEndTimeChosen",
            propertyTypeId: "System.Nullable`1[[System.TimeOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        venueFullAddress: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Venue Full Address"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 41
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VenueFullAddress",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationTookPlace: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Took Place"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 42
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationTookPlace",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 43
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        emProvider: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "EM Provider"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 44
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EmProvider",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        purchaseOrderNumber: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Purchase Order No"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 45
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PurchaseOrderNumber",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationStatusLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Status"
                },
                {
                    foreignEntityAlias: "CaseReferralsByMediationStatus",
                    typeDescription: "GM Mediation Statuses",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 46
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationStatusLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        videoMeetingMeetingRoom: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "VM Meeting Room"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 47
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VideoMeetingMeetingRoom",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        videoMeetingTimeSlot: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "VM Time Slot"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 48
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VideoMeetingTimeSlot",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        welcomer: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Welcomer"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 49
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Welcomer",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationTypeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Type"
                },
                {
                    foreignEntityAlias: "CaseReferralsByMediationType",
                    typeDescription: "GM Mediation Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseReferral+MediationTypeLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 50
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationTypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        videoMeetingInformation: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Video Meeting Information"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 51
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "VideoMeetingInformation",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        zoomAccount: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Zoom Account"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 52
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ZoomAccount",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingLeadTimeDisabled: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Meeting Lead Time Disabled?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 53
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingLeadTimeDisabled",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        case: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Case",
            propertyTypeId: "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        completedByStaffMember: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CompletedByStaffMember",
            propertyTypeId: "GlobalMediation.Data.Entities.StaffMember, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationStatusLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationStatusLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationTypeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationTypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediator: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Mediator",
            propertyTypeId: "GlobalMediation.Data.Entities.Mediator, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        officerLocalAuthorityGroupStaffMember: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OfficerLocalAuthorityGroupStaffMember",
            propertyTypeId: "GlobalMediation.Data.Entities.LocalAuthorityGroupStaffMember, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        venue: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Venue",
            propertyTypeId: "GlobalMediation.Data.Entities.Venue, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.CaseReferral, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

